<template>
  <div v-if="isLiveCourseUser">
    <v-breadcrumbs :items="breadCrumbs">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item @click="clickBreadCrumb(item.text)" :disabled="item.disabled" :link="true">
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
    <v-btn
        @click="loadData()"
        class="ma-2"
        outlined
        x-small
        color="indigo"
    >
      Zurück
    </v-btn>
    <Course ref="course" @reload="loadData" :course-run="courseRun"/>
  </div>
  <v-container class="grey lighten-5" v-else-if="!courseRun">
    <v-dialog
        v-model="dialog"
        persistent
    >
      <PrivacyDialog @accepted="acceptPrivacy"/>
    </v-dialog>
    <v-snackbar :timeout="5000" :value="errorZvu" color="error" left shaped top style="margin-top: 50px">Das
      Ablaufdatum ihrer
      Zuverlässigkeitsüberprüfung fehlt oder liegt in der Vergangenheit.
    </v-snackbar>
    <v-snackbar :timeout="5000" :value="errorCheckbox" color="error" left shaped top>Die
      Bestätigung ihres
      Sicherheitsbeauftragten bzgl. der Teilnehmerüberwachung fehlt.
    </v-snackbar>
    <v-snackbar :timeout="5000" :value="errorBday" color="error" left shaped top style="margin-top: 100px">Ihr
      Geburtsdatum ist nicht
      hinterlegt.
    </v-snackbar>
    <v-breadcrumbs :items="breadCrumbs">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item @click="clickBreadCrumb(item.text)" :disabled="item.disabled" :link="true">
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
    <div v-if="courseRunsStarted.length>0">
      <h2>Deine gestarteten Schulungen</h2>
      <br/>
      <v-row>
        <v-col
            v-for="courseRun in courseRunsStarted"
            :key="courseRun.id"
            cols="12"
            sm="4"
        >
          <CourseOverview :course-run="courseRun" @run="runCourse"/>
        </v-col>
      </v-row>
      <br/>
    </div>
    <h2>Deine offenen Schulungen</h2>
    <br/>
    <h3 v-if="courseRunsOpen.length===0">Dir sind keine Schulungen zugewiesen.</h3>
    <v-row>
      <v-col
          v-for="courseRun in courseRunsOpen"
          :key="courseRun.id"
          cols="12"
          sm="4"
      >
        <CourseOverview :course-run="courseRun" @run="runCourse"/>
      </v-col>
    </v-row>
    <div v-if="courseRunsDone.length>0">
      <h2 style="margin-top: 24px">Deine abgeschlossenen Schulungen</h2>
      <br/>
      <v-row>
        <v-col
            v-for="courseRun in courseRunsDone"
            :key="courseRun.id"
            cols="12"
            sm="4"
        >
          <CourseOverview :course-run="courseRun" @run="runCourse"/>
        </v-col>
      </v-row>
    </div>
  </v-container>
  <v-container style="height: 100%; width: 100%" v-else>
    <v-breadcrumbs :items="breadCrumbs">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item @click="clickBreadCrumb(item.text)" :disabled="item.disabled" :link="true">
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
    <v-btn
        @click="loadData()"
        class="ma-2"
        outlined
        x-small
        color="indigo"
    >
      Zurück
    </v-btn>
    <Course @reload="loadData" :course-run="courseRun"/>

  </v-container>
</template>

<script>
import CourseOverview from "@/components/CourseOverview";
import PrivacyDialog from "@/components/PrivacyDialog";
import Course from "@/components/sites/Course.vue";
import moment from "moment";

export default {
  name: "CourseList",
  components: {Course, PrivacyDialog, CourseOverview},
  methods: {
    clickBreadCrumb(text) {
      if (this.courseRun && text === "Deine Schulungen") {
        this.loadData();
      }
    },
    loadData() {
      this.courseRun = null;
      this.partId = null;
      this.$httpUserApi.get((result) => {
        this.isLiveCourseUser = result.isLiveCourseUser;
        if (this.isLiveCourseUser) {
          this.courseRun = result.courseRuns[0];
          this.$refs.course.setPartRunNull();
        } else {
          this.courseRuns = result.courseRuns;
          this.dialog = !result.isDataProtectionAccepted;
        }
      })
    },
    runCourse(courseRun, partId) {
      if (courseRun.hasRequirements) {
        let userId = this.$httpUserApi.userId();
        this.$httpUserApi.getUser(userId, (data) => {
          let hasError = false;
          if (courseRun.course.requireBirthdate && !data.isBirthdayValid()) {
            hasError = true;
            this.errorBday = true;
            setTimeout(() => this.errorBday = false, 3000);
          }
          if (courseRun.course.requireZvuExpirationDate && !data.isZvuPassed()) {
            hasError = true;
            this.errorZvu = true;
            setTimeout(() => this.errorZvu = false, 3000);
          }
          if (courseRun.course.requireIsHimself && !data.isHimself) {
            hasError = true;
            this.errorCheckbox = true;
            setTimeout(() => this.errorCheckbox = false, 3000);
          }

          if (hasError) {
            return null;
          }
        });
      }
      this.partId = partId;
      this.courseRun = courseRun;

    },
    acceptPrivacy() {
      this.dialog = false;
      this.$httpUserApi.acceptDataProtection()
    },
    download(courseRun) {
      this.$httpDownloadApi.download(courseRun.courseRunDetails.certificateLink, "Zertifikat");
    }
  },
  mounted() {
    this.loadData();
  },
  data: () => ({
    courseRuns: [],
    courseRun: null,
    partId: null,
    isLiveCourseUser: false,
    errorText: "",
    errorBday: false,
    errorZvu: false,
    errorCheckbox: false,
    dialog: false
  }),
  computed: {

    courseRunsDone() {
      return this.courseRuns.filter((run) => run.isDone);
    },
    courseRunsOpen() {
      return this.courseRuns.filter((run) => run.notStarted);
    },
    courseRunsStarted() {
      return this.courseRuns.filter((run) => run.isStartedButNotDone);
    },
    breadCrumbs() {
      if (this.courseRun === null) {
        return [{
          text: "Deine Schulungen", disabled: true
        }]
      } else {
        return [{
          text: "Deine Schulungen", disabled: false
        }, {
          text: this.courseRun.course.title
        }]
      }
    }
  },
}
</script>

<style scoped>

</style>
